<template>
    <div>
        <b-container fluid class="mt--7">
            <b-overlay v-if="isList" :show="!loaded" rounded="sm">
                <list-items
                    title="Assets Management"
                    :items="assets"
                    ref="table"
                >
                    <import-form
                        subject="Assets"
                        v-model="importModal"
                        @cancel="hideModal()"
                        :fields="assetFields"
                        :upload-record="uploadAssetRecord"
                        settings-key-name="assetUploadKey"
                    ></import-form>

                    <page-actions
                        :buttons-actions="buttonActions"
                        control-class="float-right"
                        control-size="sm"
                    />
                </list-items>
            </b-overlay>
            <view-item :id="id" v-else></view-item>
        </b-container>
    </div>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import ImportForm from '@/components/ImportForm.vue'

import PageActions from '@/components/PageActions.vue'

import popupMixins from '@/mixins/popupMixins'
import showItemHelper from '@/mixins/showItemHelper'
import permissionsMixins from '@/mixins/permissionsMixins'
import importMixins from '@/mixins/importMixins'

const assetFields = [
    { name: 'name', required: true, type: 'text' },
    { name: 'model_no', required: true, type: 'text' },
    { name: 'serial_no', required: false, type: 'text' },
    { name: 'asset_type_name', required: true, type: 'text' },
    { name: 'customer_code', required: true, type: 'text' },
    { name: 'manufacturer_name', required: true, type: 'text' },
    { name: 'vendor', required: true, type: 'text' },
    { name: 'last_service_date', required: false, type: 'text' },
    { name: 'next_service_date', required: false, type: 'text' },
    { name: 'warranty_expiry_date', required: false, type: 'text' },
    { name: 'contract_expiry_date', required: false, type: 'text' },
    { name: 'frequency', required: true, type: 'text' },
    { name: 'description', required: false, type: 'text' },
    { name: 'service_week_day', required: false, type: 'text' },
    { name: 'service_time_of_day', required: false, type: 'text' },
    { name: 'default_engineer_id', required: false, type: 'text' },
]

export default {
    name: 'assets',
    components: {
        ListItems,
        ViewItem,
        ImportForm,
        PageActions,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins, importMixins],
    data: () => {
        return {
            loaded: false,
            importModal: false,
            ListItems,
            assetFields,
            item: null,
        }
    },

    computed: {
        
        assets() {
            const assets = this.$store.state.assets.assets
            console.log('assets', assets)
            return assets
        },
        asset_types() {
            const types = this.$store.state.assets.types
            console.log('types', types)
            return types
        },
        vendors() {
            // const vendors = this.$store.state.assets.vendors
            // console.log('vendors', vendors)
            // return vendors
            return this.$store.state.assets.vendors
        },
        newRoute() {
            return this.$route.path + '/' + this.id + '/usage'
        },

        freqSettingKey() {
            return this.$store.state.company.settingKeys.assetFrequencyKey
        },
        buttonActions() {
            const actions = []
            if (this.hasPermissionCreate) {
                actions.push(
                    {
                        action: () => this.createNewAsset(true),
                        icon: 'plus-circle',
                        variant: 'light',
                        tooltip: 'Create New Asset',
                    },
                    {
                        action: () => this.createNewAsset(false),
                        icon: 'person',
                        variant: 'light',
                        tooltip: 'Create New CRM',
                    },
                    {
                        action: () => this.importOrders(),
                        icon: 'upload',
                        variant: 'light',
                        tooltip: 'Import Assets',
                    }
                )
            }
            if (this.hasPermissionView) {
                actions.push({
                    action: () => this.exportOrders(),
                    icon: 'download',
                    variant: 'light',
                    tooltip: 'Export Assets',
                })
            }
            return actions
        },
    },
    watch: {
        assets: {
            handler: function () {
                this.loaded = true
            },
            deep: true,
        },
    },

    created() {
        console.log(' this.freqSettingKey', this.freqSettingKey)
        this.$store.dispatch('company/fetchConfiguration', this.freqSettingKey)

        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('locations/fetchWarehouses')
    },

    methods: {
        createNewAsset(x) {
            this.$router.push(`${this.$route.path}/0${x?'':'?crm=1'}`)
        },
        importOrders() {
            this.importModal = true
        },
        exportOrders() {
            this.$refs.table.showDetailsDialog()
        },
        async uploadAssetRecord(
            dataRecord,
            statusRecord,
            check,
            statuses,
            setLoading
        ) {
            try {
                let {
                    name,
                    asset_type_name,
                    serial_no,
                    model_no,
                    manufacturer_name,
                    customer_code,
                    description,
                    vendor: vendor_name,
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    frequency,
                    service_week_day,
                    service_time_of_day,
                    contract_expiry_date,
                    default_engineer_id,
                } = dataRecord

                statusRecord.status = statuses.CHECKING

                console.log('check', check)
                if (check != 1) throw new Error('Invalid Entry!')

                const vendor_id = this.getCustomEntityId(
                    vendor_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )
                const manufacturer_id = this.getCustomEntityId(
                    manufacturer_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )

                const type_id = this.getCustomEntityId(
                    asset_type_name,
                    this.asset_types,
                    'name',
                    'asset_type'
                )

                //customer ID
                const customerfetchparam = {
                    query: '',
                    page: 1,
                    filters: { code: customer_code },
                }
                await this.$store.dispatch(
                    'customers/fetch',
                    customerfetchparam
                )
                const items = this.$store.state.customers.items

                console.log('Customers', { items })

                if (items.length == 0)
                    throw new Error("Customer Code Doesn't exist")

                const { id: customer_id, location_section_id } = items[0]
                if (!location_section_id) throw new Error('Location Not Found')

                default_engineer_id = default_engineer_id || null
                contract_expiry_date = contract_expiry_date || null
                service_time_of_day = service_time_of_day || null
                service_week_day = service_week_day || null
                next_service_date = next_service_date || null
                const notes = null
                const manual_url = null
                const service_plan_url = null
                const image_url = null
                const order_template_id = null

                const payload = {
                    name,
                    type_id,
                    serial_no,
                    model_no,
                    manufacturer_id,
                    customer_id,
                    vendor_id,
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    location_section_id,
                    frequency,
                    description,
                    service_week_day,
                    service_time_of_day,
                    contract_expiry_date,
                    default_engineer_id,
                    notes,
                    manual_url,
                    service_plan_url,
                    image_url,
                    order_template_id,
                }

                console.log('Parameters', payload)

                const res = await this.$store.dispatch('assets/create', {
                    payload,
                })

                console.log('response:', res)

                // set status to complete if the upload was successful
                statusRecord.status = statuses.COMPLETE
            } catch (err) {
                console.error('err', err)
                statusRecord.error_list =
                    typeof err.message == 'string'
                        ? [['error', [err.message]]]
                        : Object.entries(err.message)
                statusRecord.status = statuses.ERROR
            } finally {
                setLoading(false)
            }
        },
    },
}
</script>
<style></style>
